// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 12302-游泳者详情查询 GET /web/v1/swimmer/detail */
export async function getSwimmerDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimmerDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimSwimmerDetailVo>("/web/v1/swimmer/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 12303-根据ID查询游泳者详情 GET /web/v1/swimmer/detail/${param0} */
export async function getSwimmerDetailById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimmerDetailByIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimSwimmerDetailVo>(
    `/web/v1/swimmer/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 12305-根据身份证号查询游泳者详情 GET /web/v1/swimmer/detail/idcard/${param0} */
export async function getSwimmerDetailByIdCard(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimmerDetailByIdCardParams,
  options?: { [key: string]: any }
) {
  const { idCard: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimSwimmerDetailVo>(
    `/web/v1/swimmer/detail/idcard/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 12304-根据手机号查询游泳者详情 GET /web/v1/swimmer/detail/phone/${param0} */
export async function getSwimmerDetailByPhone(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimmerDetailByPhoneParams,
  options?: { [key: string]: any }
) {
  const { phone: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimSwimmerDetailVo>(
    `/web/v1/swimmer/detail/phone/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 12310-批量添加假人游泳者 POST /web/v1/swimmer/dummy/batchAdd */
export async function batchAddDummySwimmers(
  body: API.DummySwimmerBatchAddReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVODummySwimmerBatchAddRespVO>(
    "/web/v1/swimmer/dummy/batchAdd",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 12311-假人游泳者列表查询 POST /web/v1/swimmer/dummy/list */
export async function getDummySwimmerList(
  body: API.DummySwimmerListQueryVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVODummySwimmerListRespVO>(
    "/web/v1/swimmer/dummy/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 12309-删除紧急联系人 DELETE /web/v1/swimmer/emergency/delete */
export async function deleteSwimmerEmergencyContact(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSwimmerEmergencyContactParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/swimmer/emergency/delete", {
    method: "DELETE",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 12307-游泳者紧急联系人详情 GET /web/v1/swimmer/emergency/detail */
export async function getSwimmerEmergencyContactDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimmerEmergencyContactDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOEmergencyContactRespVO>(
    "/web/v1/swimmer/emergency/detail",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 12306-游泳者紧急联系人列表 GET /web/v1/swimmer/emergency/list */
export async function getSwimmerEmergencyContactList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimmerEmergencyContactListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListEmergencyContactRespVO>(
    "/web/v1/swimmer/emergency/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 12308-新增/更新紧急联系人 POST /web/v1/swimmer/emergency/save */
export async function saveSwimmerEmergencyContact(
  body: API.EmergencyContactSaveReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/swimmer/emergency/save", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 12301-游泳者分页列表查询 POST /web/v1/swimmer/list */
export async function getSwimmerList(
  body: API.SwimSwimmerListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimSwimmerListVo>(
    "/web/v1/swimmer/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
